import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {useDispatch, useSelector} from 'react-redux';
import {setPostUpdateWager} from '../../store/thunk/setPostUpdateWager';
import Dialog from '@material-ui/core/Dialog';
import { setPostCopyBalance } from '../../store/thunk/setPostCopyBalance';
import { setPostAirUpdateBalance } from '../../store/thunk/setPostAirUpdateBalance';
import { setPostUpdateBalance } from '../../store/thunk/setPostUpdateBalance';
import { Thunk } from '../../../../store/requestApi/thunk';
import { Allow as AllowMap} from '../../../../settings/allow';
import { ReactComponent as Edit } from './edit.svg';
import { setPostUserDescription } from '../../store/thunk/setPostUserDescription';
import { setPostCopyWager } from '../../store/thunk/setPostCopyWager';
import ModalChangeCurrency from '../ModalChangeCurrency';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex', 
        marginBottom: 5, 
        alignItems: 'center'
    },
    label: {
        color: 'hsla(0,0%,100%,.5)', 
        fontFamily: 'PT-sans, sans-serif', 
        fontSize: 12, 
        textAlign: 'right', 
        width: 100, 
        paddingTop: 2
    },
    description: {
        paddingLeft: 16, 
        color: '#fff', 
        fontFamily: 'PT-sans, sans-serif', 
        fontSize: 14, 
        lineHeight: 0
    }
}))

const DetalizationItem = ({label, description, id}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [confirmation, setConfirmation] = React.useState(false);
    const [confirmationCopy, setConfirmationCopy] = React.useState(false);
    const [zeroBalance, setZeroBalance] = React.useState(false);
    const [showModalWagerSettings, setShowModalWagerSettings] = React.useState('');
    const [amount, setAmount] = React.useState(0);
    const [descriptionName, setDescriptionName] = React.useState();
    const [isShowEditDescription, setIsShowEditDescription] = React.useState(false);
    const [isShowChangeCurrency, setIsShowChangeCurrency] = React.useState(false);

    const handleChangeModeCurrency = () => {
        setIsShowChangeCurrency(value => !value)
    }

    React.useEffect(() => {
        if (label === 'Имя custom' && description) {
            setDescriptionName(description)
        }
    }, [label, description])

    const view = useSelector(state => state.auth.admin);
    const Allow = AllowMap();

    return (
        <div className={classes.root}>
            <span className={classes.label}>{label}: </span>
            <span className={classes.description} style={{color: label === 'Статус' && description === 'Online' ? '#3cde0b' : label === 'Статус' && description === 'Offline' && 'red' }}>{description}</span>
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', rowGap: 10}}>
                {
                    label === 'Wager' && view?.allow?.includes(Allow.ManagementBalance.allow) &&
                    <span 
                    style={{marginLeft: 12, padding: 5, color: '#2f2f2f', background: '#fc3450', borderRadius: 4, cursor: 'pointer'}}
                    onClick={() => setConfirmation(true)}
                    >Обнулить</span>
                }
                {
                    (label === 'Wager PAY' || label === 'Wager Freespin') && view?.allow?.includes(Allow.ManagementBalance.allow) &&
                    <span 
                    style={{marginLeft: 12, padding: 5, color: '#2f2f2f', background: '#fc3450', borderRadius: 4, cursor: 'pointer'}}
                    onClick={() => setShowModalWagerSettings(label)}
                    >Изменить</span>
                }
                {
                    label === 'Имя custom' && (
                        <Edit style={{marginLeft: 10, cursor: 'pointer'}} onClick={() => setIsShowEditDescription(true)}/>
                    )
                }
                {
                    label === 'Баланс' && view?.allow?.includes(Allow.ManagementBalance.allow) &&
                    <span 
                    style={{marginLeft: 12, padding: 5, color: '#2f2f2f', background: '#fc3450', borderRadius: 4, cursor: 'pointer'}}
                    onClick={() => setZeroBalance(true)}
                    >Обнулить</span>
                }
                {
                    (label === 'Wager' || label === 'Баланс' || label === 'Воздушный баланс') && view?.allow?.includes(Allow.ManagementBalance.allow) &&
                    <span 
                    style={{marginLeft: 12, padding: 5, color: '#2f2f2f', background: '#fc3450', borderRadius: 4, cursor: 'pointer', display: 'flex', justifyContent: 'center'}}
                    onClick={() => setConfirmationCopy(true)}
                    >Списать</span>
                }
                {
                    label === 'Валюта' && view?.allow?.includes(Allow.ManagementBalance.allow) &&
                    <span 
                    style={{marginLeft: 12, padding: 5, color: '#2f2f2f', background: '#fc3450', borderRadius: 4, cursor: 'pointer'}}
                    onClick={handleChangeModeCurrency}
                    >Изменить</span>
                }
            </div>
           
            <Dialog onClose={() => setConfirmation(false)} open={confirmation}>
                <div style={{padding: 20}}>
                    <span className={classes.label} style={{color: '#2F2F2F'}}>Вы точно хотите обнулить Wager?</span>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginTop: 12}}>
                        <span style={{marginLeft: 12, width: '50%', padding: 5, color: '#2f2f2f', background: '#fc3450', borderRadius: 4, cursor: 'pointer', display: 'flex', justifyContent: 'center'}}
                            onClick={() => {
                                dispatch(setPostUpdateWager({id}));
                                setConfirmation(false);
                            }} 
                        >Да</span>
                        <span style={{marginLeft: 12, width: '50%', padding: 5, color: '#2f2f2f', border: '1px solid #fc3450', borderRadius: 4, cursor: 'pointer', display: 'flex', justifyContent: 'center'}} onClick={() => setConfirmation(false)}>Отмена</span>
                    </div>
                </div>
            </Dialog>
            <Dialog onClose={() => setIsShowEditDescription(false)} open={isShowEditDescription}>
                <div style={{padding: 20, minWidth: 250}}>
                    <input 
                        type="text" 
                        style={{width: 250, padding: 10, outline: 'none', border: '1px solid #eee', marginTop: 12, borderRadius: 4}} 
                        placeholder="Введите имя пользователя" 
                        onChange={(v) => {
                            setDescriptionName(v.target.value)
                        }}
                        value={descriptionName}
                    />
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginTop: 12}}>
                        <span style={{marginLeft: 12, width: '50%', padding: 5, color: '#2f2f2f', background: '#fc3450', borderRadius: 4, cursor: 'pointer', display: 'flex', justifyContent: 'center'}}
                            onClick={() => {
                                dispatch(setPostUserDescription({
                                    id,
                                    name: descriptionName
                                }))
                                setIsShowEditDescription(false);
                            }} 
                        >Подтвердить</span>
                        <span style={{marginLeft: 12, width: '50%', padding: 5, color: '#2f2f2f', border: '1px solid #fc3450', borderRadius: 4, cursor: 'pointer', display: 'flex', justifyContent: 'center'}} onClick={() => setIsShowEditDescription(false)}>Отмена</span>
                    </div>
                </div>
            </Dialog>
            <Dialog onClose={() => setZeroBalance(false)} open={zeroBalance}>
                <div style={{padding: 20}}>
                    <span className={classes.label} style={{color: '#2F2F2F'}}>Вы точно хотите обнулить Баланс?</span>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginTop: 12}}>
                        <span style={{marginLeft: 12, width: '50%', padding: 5, color: '#2f2f2f', background: '#fc3450', borderRadius: 4, cursor: 'pointer', display: 'flex', justifyContent: 'center'}}
                            onClick={() => {
                                dispatch(setPostUpdateBalance({id}));
                                setZeroBalance(false);
                            }} 
                        >Да</span>
                        <span style={{marginLeft: 12, width: '50%', padding: 5, color: '#2f2f2f', border: '1px solid #fc3450', borderRadius: 4, cursor: 'pointer', display: 'flex', justifyContent: 'center'}} onClick={() => setZeroBalance(false)}>Отмена</span>
                    </div>
                </div>
            </Dialog>
            <Dialog onClose={() => {
                setConfirmationCopy(false);
                setAmount(0)
            }} open={confirmationCopy}>
                <div style={{padding: 20}}>
                    <span className={classes.label} style={{color: '#2F2F2F', fontSize: 16, textAlign: 'center'}}>На какую сумму списать {label === 'Wager' ? 'Вейджер' : 'Баланс'}?</span>
                    <input 
                        type="text" 
                        style={{width: '100%', padding: 10, outline: 'none', border: '1px solid #eee', marginTop: 12, borderRadius: 4}} 
                        placeholder="Введите сумму" 
                        value={label !== 'Воздушный баланс' ? amount : description}
                        disabled={label === 'Воздушный баланс'}
                        onChange={(v) => {
                            if (!isNaN(+v.target.value) || v.target.value === '.') {
                                setAmount(v.target.value);
                            }
                        }}
                    />
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginTop: 12}}>
                        <span 
                            style={{marginLeft: 12, width: '50%', padding: 5, color: '#2f2f2f', background: '#fc3450', borderRadius: 4, cursor: 'pointer', display: 'flex', justifyContent: 'center'}}
                            onClick={() => {
                                console.log(label)
                                if (label === 'Wager') {
                                    dispatch(setPostCopyWager({
                                        id,
                                        amount
                                    }));
                                    setAmount(0)
                                }

                                if (label === 'Баланс') {
                                    dispatch(setPostCopyBalance({
                                        id,
                                        amount
                                    }))
                                    setAmount(0)
                                }

                                if (label === 'Воздушный баланс') {
                                    dispatch(setPostAirUpdateBalance({
                                        user_id: id,
                                    }))
                                    setAmount(0)
                                }
                                
                                setConfirmationCopy(false);
                            }}
                        >Списать</span>
                        <span style={{marginLeft: 12, width: '50%', padding: 5, color: '#2f2f2f', border: '1px solid #fc3450', borderRadius: 4, cursor: 'pointer', display: 'flex', justifyContent: 'center'}} 
                        onClick={() => {
                            setConfirmationCopy(false)
                            setAmount(0)
                        }}>Отмена</span>
                    </div>
                </div>
            </Dialog>
            <Dialog onClose={() => {
                setShowModalWagerSettings(false)
                setAmount(0)
            }} open={showModalWagerSettings}>
                <div style={{padding: 20}}>
                    <span className={classes.label} style={{color: '#2F2F2F', fontSize: 16, textAlign: 'center'}}>Какой WAGER установить для {label}?</span>
                    <input 
                        type="text" 
                        style={{width: '100%', padding: 10, outline: 'none', border: '1px solid #eee', marginTop: 12, borderRadius: 4}} 
                        placeholder="Введите wager" 
                        value={amount}
                        onChange={(v) => {
                            if (!isNaN(+v.target.value) || v.target.value === '.') {
                                setAmount(v.target.value);
                            }
                        }}
                    />
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginTop: 12}}>
                        <span 
                            style={{marginLeft: 12, width: '50%', padding: 5, color: '#2f2f2f', background: '#fc3450', borderRadius: 4, cursor: 'pointer', display: 'flex', justifyContent: 'center'}}
                            onClick={() => {
                                if (label === 'Wager PAY') {
                                    dispatch(Thunk.Users.SetPostUserWagerSettings({
                                        type: 'pay',
                                        amount,
                                        id
                                    }))
                                    setAmount(0)
                                }

                                if (label === 'Wager Freespin') {
                                    dispatch(Thunk.Users.SetPostUserWagerSettings({
                                        type: 'freespin',
                                        amount,
                                        id
                                    }))
                                    setAmount(0)
                                }
                                setShowModalWagerSettings(false);
                            }}
                        >Установить</span>
                        <span style={{marginLeft: 12, width: '50%', padding: 5, color: '#2f2f2f', border: '1px solid #fc3450', borderRadius: 4, cursor: 'pointer', display: 'flex', justifyContent: 'center'}} 
                        onClick={() => {
                            setShowModalWagerSettings(false)
                            setAmount(0)
                        }}>Отмена</span>
                    </div>
                </div>
            </Dialog>
            {
                isShowChangeCurrency && (
                    <ModalChangeCurrency handleChangeMode={handleChangeModeCurrency} user_id={id} currency={description} />
                )
            }
        </div>
    )
}

export default DetalizationItem;